import { Pipe, PipeTransform } from '@angular/core';
import { crmExportValue } from '../../../helpers/crm-export-value';

@Pipe({
    name: 'crmExportCompare',
    pure: true,
    standalone: false
})
export class CrmExportComparePipe implements PipeTransform {
  transform(crm: string, field: string): boolean {
    if (!crm || !field) return false;
    return (crmExportValue(crm) ? crmExportValue(crm) : undefined) === crmExportValue(field.toUpperCase());
  }
} 
